import request from "@/api/request";

// 插入一个分享记录
export function insertShareHistroy(data) {
  return request({
    url: "/api/kp/shareHistory/insert",
    method: "post",
    data: data,
  });
}

export function selectReceive() {
  return request({
    url: "/api/kp/shareHistory/selectReceive",
    method: "get",
  });
}

export function selectSend() {
  return request({
    url: "/api/kp/shareHistory/selectSend",
    method: "get",
  });
}
export function selectReceiveGroup() {
  return request({
    url: "/api/kp/shareHistory/selectReceiveGroup",
    method: "get",
  });
}